export function AmbientGlow() {
  return (
    <div
      className="ambient-glow"
      style={{
        position: 'fixed',
        top: 0,
        left: '50%',
        width: '60vw',
        height: '40vh',
        background: 'radial-gradient(ellipse at center, var(--accent-g), transparent 70%)',
        pointerEvents: 'none',
        transform: 'translateX(-50%)',
        animation: 'breathe 8s ease-in-out infinite',
        zIndex: 0,
      }}
    />
  )
}
